import { render, staticRenderFns } from "./Scholars.vue?vue&type=template&id=8939a592"
import script from "./Scholars.vue?vue&type=script&lang=js"
export * from "./Scholars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports